// Storage keys
const STORAGE_KEYS = {
  MATERIALS: 'dish-costing-materials',
  RECIPES: 'dish-costing-recipes',
  CATEGORIES: 'dish-costing-categories',
  MATERIAL_CATEGORIES: 'dish-costing-material-categories',
  RECIPE_CATEGORIES: 'dish-costing-recipe-categories',
  LANGUAGE: 'dish-costing-language',
};

// No longer need generateId - using database sequences

// Generic storage functions
export const getFromStorage = (key, defaultValue = []) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error(`Error reading from localStorage for key ${key}:`, error);
    return defaultValue;
  }
};

export const saveToStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error(`Error saving to localStorage for key ${key}:`, error);
    return false;
  }
};

// Materials storage
export const getMaterials = () => getFromStorage(STORAGE_KEYS.MATERIALS);
export const saveMaterials = (materials) => saveToStorage(STORAGE_KEYS.MATERIALS, materials);

// Recipes storage
export const getRecipes = () => getFromStorage(STORAGE_KEYS.RECIPES);
export const saveRecipes = (recipes) => saveToStorage(STORAGE_KEYS.RECIPES, recipes);

// Material categories storage
export const getMaterialCategories = () => getFromStorage(STORAGE_KEYS.MATERIAL_CATEGORIES);
export const saveMaterialCategories = (categories) => saveToStorage(STORAGE_KEYS.MATERIAL_CATEGORIES, categories);

// Recipe categories storage
export const getRecipeCategories = () => getFromStorage(STORAGE_KEYS.RECIPE_CATEGORIES);
export const saveRecipeCategories = (categories) => saveToStorage(STORAGE_KEYS.RECIPE_CATEGORIES, categories);

// Language storage
export const getLanguage = () => {
  const lang = localStorage.getItem(STORAGE_KEYS.LANGUAGE);
  return lang || 'en';
};

export const saveLanguage = (language) => {
  localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
};

// Initialize default data if empty
export const initializeDefaultData = () => {
  const materialCategories = getMaterialCategories();
  const recipeCategories = getRecipeCategories();

  // Initialize default material categories if empty
  if (materialCategories.length === 0) {
    const defaultCategories = [
      { id: 0, nameEn: 'Unnamed', nameAr: 'غير مسمى' }
    ];
    saveMaterialCategories(defaultCategories);
  }

  // Initialize default recipe categories if empty
  if (recipeCategories.length === 0) {
    const defaultCategories = [
      { id: 0, nameEn: 'Unnamed', nameAr: 'غير مسمى', image: '' }
    ];
    saveRecipeCategories(defaultCategories);
  }
}; 